import React, { Component } from 'react'
import {connect} from "react-redux"
import Quotes from './features/quote/Quotes';
import Fields from './features/fields/fields';
import Header from './components/Header';
import $ from 'jquery'
import {newGUIDforQuote,fillFromURL,addObject} from "./features/fields/fieldsSlice"
import {getQuote} from "./features/quote/quoteSlice"
import { v4 as uuidv4 } from 'uuid';
import './App.css';
import _ from 'lodash';
import LogRocket from 'logrocket';
import { setQuoteProgress, setShowQuotes } from './features/ui/uiSlice';


class App extends Component {
  constructor(props){
    super(props);
    LogRocket.init('hhsytw/mib-quoter-2023');
    this.overallProgress = this.overallProgress.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);

    this.percentcompleted = 0;
    this.currentStep = 0;
    this.nextStep = 1;

    this.steps = [
      {
        name: "User Info",
        title: "Enter your personal information",
        list: [{field:"user"}],
        stepProgress: 0,
        submitButton: React.createRef(),
        onSubmit: this.onSubmitForm
      },
      {
        name: "Vehicle(s) Info",
        title: "Enter your vehicle(s) information",
        list: [{field:"vhcls"}],
        stepProgress:0,
        submitButton: React.createRef(),
        onSubmit: this.onSubmitForm
      },
      {
        name: "Driver(s) Info",
        title: "Enter your driver(s) information",
        list: [{field:"drivs"}],
        stepProgress:0,
        submitButton: React.createRef(),
        onSubmit: this.onSubmitForm
      }
    ]

    

    this.props.newGUIDforQuote();
    
    this.props.addObject("vhcls",0);
    this.props.addObject("drivs",0);
    
    this.overallProgressValue = React.createRef();

    this.props.fillFromURL();
  }
  overallProgress(){
    var stepsincomplete = _.chain(this.steps).map((step,index)=>{return {i:index,stepProgress:step.stepProgress}}).filter((step)=>step.stepProgress<1).value();
    this.nextStep = (stepsincomplete.length > 0)?stepsincomplete[0].i:this.steps.length-1;

    var completed = _.sumBy(this.steps,"stepProgress");
    this.percentcompleted = (completed/this.steps.length)*100;
    // console.log()
    window.localStorage.setItem("perc",Math.round(this.percentcompleted));
    this.props.setQuoteProgress(Math.round(this.percentcompleted));
    //this.overallProgressValue.current.innerHTML = Math.round(percentcompleted);
  }
  onStepProgress(stepOrder,fields){
    var allfields = Object.values(fields)
    var completed = _.filter(allfields,(e)=>e)
    this.steps[stepOrder].stepProgress = completed.length/allfields.length;
   // if(this.overallProgressValue.current !== null)
    this.overallProgress()

  }
  componentDidMount(){
    this.overallProgress()
  }
  changeToStep(step){
    
    if(this.steps[step].stepProgress > 0){
      this.changeStep(step);
    }
    
  }
  changeStep(step){
          
    // document.querySelector("#quote-step-"+step).classList.remove("quote-step--shown");
    // document.querySelector("#quote-step-indicator-"+step).classList.remove("quote-step-indicator--active");
    var elem = document.querySelector("#quote-step-"+step);

    document.querySelector(".quote-step--shown").classList.remove("quote-step--shown");
    elem.classList.add("quote-step--shown");
      
    document.querySelector("#quote-step-indicator-"+this.currentStep).classList.remove("quote-step-indicator--active");
    document.querySelector("#quote-step-indicator-"+step).classList.add("quote-step-indicator--active");
    
    $("html, body").animate({ scrollTop: 0 },300);

    this.currentStep = step;

  }
  onSubmitForm(valid){
    if(valid){
      document.querySelector("#quote-step-indicator-"+this.currentStep).classList.add("quote-step-indicator--completed");
        this.changeStep(this.nextStep)   
    }else{
      document.querySelector("#quote-step-indicator-"+this.currentStep).classList.remove("quote-step-indicator--completed");
    }
    if(this.percentcompleted === 100){
      this.props.setShowQuote(true);

      var step = document.querySelector(".quote-step--shown");

      document.querySelector(".quote-step-indicator--active").classList.remove("quote-step-indicator--active");
  
      step.classList.remove("quote-step--shown");

      document.querySelector("#quote-step-X").classList.add("quote-step--shown")
      
      this.props.getQuote();
    }else{
      this.props.setShowQuote(false);
    }
    //console.log(valid);
  }
  render() {
    return (

      <div className='app'>
        <Header/>
        <div className="quoter">
          <div className='quote-steps'>
            {this.steps.map(((step,index)=>
              (
                <div key={uuidv4()} id={'quote-step-indicator-'+index} className={(this.currentStep == index)?'quote-step-indicator quote-step-indicator--active':'quote-step-indicator'} onClick={(e)=>{this.changeToStep(index)}}>{step.name}</div>
              )
            ))}
          </div>
          <div className='quote-fields'>
            {this.steps.map(((step,index)=>
              (
              <div key={uuidv4()} id={'quote-step-'+index} className={(this.currentStep == index)?'quote-step quote-step--shown':'quote-step'}>
                {(index !== 0)&&(<button className='quote-step-mobile-back' onClick={(e)=>{this.changeToStep(index-1)}}><i className="lni lni-arrow-left"></i>Back</button>)}
                <h2 key={uuidv4()}>{step.title}</h2>
                <Fields submitText={(index === this.steps.length-1)?"Get A Quote":"Next"} onSubmit={step.onSubmit} list={step.list} onProgress={(fields)=>{this.onStepProgress(index,fields)}}/>
              </div>
              )
            ))}
            <div key={uuidv4()} id='quote-step-X' className='quote-step'>
              <h3 key={uuidv4()}><i className="lni lni-checkmark"></i>You're Done!</h3>
              <p key={uuidv4()}>We're preparing your quote.</p>
              <button className='quote-step-mobile-back' onClick={(e)=>{this.changeToStep(this.steps.length-1)}}><i className="lni lni-arrow-left"></i>Back</button>
            </div>
            {/* <Fields list={[{field:"user"},{field:"vhcls"},{field:"drivs_1_brth",single:true}]}/> */}
          </div>
        
          <Quotes progressRef={this.overallProgressValue}/>

          
        </div>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => ({
  newGUIDforQuote:()=>{dispatch(newGUIDforQuote())},
  addObject:(path,index)=>{dispatch(addObject({objectPath:path,objectIndex:index}))},
  fillFromURL:()=>{dispatch(fillFromURL())},
  getQuote:()=>{dispatch(getQuote())},
  setQuoteProgress: (progress)=>{dispatch(setQuoteProgress({progress:progress}))},
  setShowQuote: (value)=>{dispatch(setShowQuotes({show:value}))}
})
export default connect(null,mapDispatchToProps)(App)